import http from '@/assets/common/http';
// ------------------------------------------获取出库汇总单
export function totalOutWarefun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出出库汇总单
export function exportTotalWarefun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/sendDoc.js